module.exports = __webpack_public_path__ + "img/magento-vs-woocommerce-showdown.eb6ec875.jpg";